import { constants } from "../constant/constants";
import { AuthType } from "../services/auth-service";
import { MsalService } from "../services/msal-service";

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) {
      return null;
    }
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    return JSON.parse(jsonPayload) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function emailFromJwtToken(token: string): string | null {
  const payload = decodeJwtPayload(token);
  const email = payload?.email ?? payload?.Email;
  if (typeof email === "string" && email.trim()) {
    return email.trim();
  }
  return null;
}

function emailFromMagicLinkToken(): string | null {
  const token = localStorage.getItem(
    constants.localStorage.keys.magicLink.accessToken,
  );
  if (!token) {
    return null;
  }
  return emailFromJwtToken(token);
}

function parseStoredAuthType(raw: string | null): AuthType | null {
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (parsed === AuthType.AzureAD || parsed === AuthType.MagicLink) {
      return parsed;
    }
  } catch {
    const numeric = Number(raw.trim());
    if (numeric === AuthType.AzureAD || numeric === AuthType.MagicLink) {
      return numeric;
    }
  }
  return null;
}

function emailFromMsalSession(): string | null {
  const cached = MsalService.getCachedBootEmail();
  if (cached) {
    return cached;
  }
  const msal = MsalService.getInstance();
  if (msal.emailaddress?.trim()) {
    return msal.emailaddress.trim();
  }
  if (msal.username?.trim()) {
    return msal.username.trim();
  }
  return null;
}

/** Email from cached session only (no network). Used for contact KV region lookup on boot. */
export function resolveBootEmail(): string | null {
  const authType = parseStoredAuthType(
    localStorage.getItem(constants.localStorage.keys.authType),
  );

  if (authType === AuthType.MagicLink) {
    return emailFromMagicLinkToken();
  }

  if (authType === AuthType.AzureAD) {
    return emailFromMsalSession();
  }

  return emailFromMagicLinkToken() ?? emailFromMsalSession();
}
